import { render } from "./HoroscopePodcastDashboard.vue?vue&type=template&id=608a629a&scoped=true"
import script from "./HoroscopePodcastDashboard.vue?vue&type=script&lang=js"
export * from "./HoroscopePodcastDashboard.vue?vue&type=script&lang=js"

import "./HoroscopePodcastDashboard.vue?vue&type=style&index=0&id=608a629a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608a629a"]])

export default __exports__